import {
  handleZipDownload,
  sanitizeInnerHtml,
  sanitizeUrl,
} from "@/utils/helper"
import ShareIcon from "@/public/icons/share-icon.svg"
import DownloadIcon from "@/public/icons/download-dark-gray.svg"
import { useEffect, useState } from "react"
import { getConfig } from "@/constants/config"
import _get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { useRef } from "react"
import { useTranslation } from "next-i18next"
import { getShortenedUrl } from "@/utils/location"
import { ConditionalWrapper } from "@/utils/index"

const SocialShare = ({
  dispatchCallback = () => {},
  cartId,
  analyticEventData,
  id,
  specFiles,
  mobileView = false,
  componentProp: { assetUrl = "", url: compUrl = "" } = {},
  enableDownload = true,
  shareCartId,
  selectedItems = [],
}) => {
  // *****
  const [shareCart, setShareCart] = useState({ show: false, id: "", url: "" })
  const [downloading, setDownloading] = useState(false)
  const url = shareCart.url || ""
  const [sites, setSites] = useState([])
  const { t } = useTranslation()
  const origin = window.location.origin
  const brandName = useRef("")
  const [socialMediaConfigs, setSocialMediaConfigs] = useState({})
  const [loading, setLoading] = useState(false)
  const emailBtnRef = useRef(null)
  const copyBtnRef = useRef(null)
  const shareBoxRef = useRef(null)
  const shareCartUrl = useRef("")
  const socialShareCopyIconPath = useRef("")
  const socialShareEmailIconPath = useRef("")
  const shareRef = useRef(null)

  useEffect(() => {
    setShareCart({
      ...shareCart,
      url: shareCartId,
    })
  }, [shareCartId])
  const [link, setLink] = useState("")
  useEffect(() => {
    getConfig().then(async config => {
      const socialMediaConfigs = _get(config, "socialMediaConfig", {})
      setSocialMediaConfigs(socialMediaConfigs)
      brandName.current = _get(config, "general?.siteName", "")
      socialShareCopyIconPath.current = _get(
        config,
        "general.socialShareCopyIconPath",
        ""
      )
      socialShareEmailIconPath.current = _get(
        config,
        "general.socialShareEmailIconPath",
        ""
      )
      shareCartUrl.current = await getShortenedUrl(
        _get(config, "general.shareCartPagePath", "")
      )
    })

    getLink().then(urlLink => {
      setLink(urlLink)
    })
  }, [])

  const handleShareCart = () => {
    if (shareCart.show) {
      setShareCart({ ...shareCart, show: false })
    } else {
      const payload = { cartId: cartId }
      if (selectedItems.length) {
        payload.sharedItems = selectedItems
      }
      if (shareCartId && !selectedItems.length) {
        const shareUrl =
          window.location.origin +
          shareCartUrl.current +
          `?share-id=${shareCartId}`
        if (cartId) {
          setLink(shareUrl)
          setShareCart({
            show: true,
            id: shareCartId,
            url: shareUrl,
          })
        }
      } else {
        setLoading(true)
        dispatchCallback("shareCart", payload)
          .unwrap()
          .then(res => {
            if (res?.sharedCartId) {
              const shareUrl =
                window.location.origin +
                shareCartUrl.current +
                `?share-id=${res.sharedCartId}`
              if (cartId) {
                setLink(shareUrl)
                setShareCart({
                  show: true,
                  id: res.sharedCartId,
                  url: shareUrl,
                })
              }
            }
            setLoading(false)
          })
      }
    }
  }

  // get component social share link url
  const getLink = async () => {
    const isFullUrl = /^https?:\/\//i
    if (url && isFullUrl.test(url)) {
      return url
    }
    if (url) {
      return `${origin}${url}`
    } else if (assetUrl && compUrl) {
      // teaser video component link all cases
      if (!isFullUrl.test(compUrl)) {
        const newcompUrl = await getShortenedUrl(compUrl)
        return `${origin}${newcompUrl}`
      } else {
        return compUrl
      }
    } else if (assetUrl) {
      return assetUrl
    } else {
      return sanitizeUrl(window.location.href)
    }
  }

  const i18n = {
    email: t("kf.share.label.email", "Email"),
    emailSubject: t("kf.share.label.emailSubject", "Shared Cart Invitation"),
    copyLink: t("kf.share.label.copyLink", "Copy Link"),
    copyLinkIndication: t("kf.share.label.copyLinkIndication", "Link Copied!"),
    yourSharedCartNumber: t(
      "kf.share.label.yourSharedCartNumber",
      {
        cartNumber: shareCart.id,
      },
      `Your cart #: ${shareCart.id}`
    ),
    linksCTA: siteKey =>
      t(
        "kf.pdp.label.aria.socialLinksCTA",
        { brandName, siteKey },
        `Go to ${brandName} ${siteKey} Page`
      ),
    openNewTabText: t(
      "kf.share.label.openNewTabText",
      "will open in a new tab"
    ),
    shareCartDesc: t(
      "kf.cart.label.shareCartDesc",
      "Share your cart or download technical specs for products in your cart."
    ),
    shareCart: t("kf.cart.label.shareCart", "Share Cart"),
    mailSubject: t("kf.share.label.emailSubject", "Shared Cart Invitation"),
    downloadSpecs: t("kf.cart.label.downloadSpecs", "Download Specs"),
  }
  const [copyIcon, setCopyIcon] = useState(false)

  useEffect(() => {
    const siteList = []
    socialMediaConfigs &&
      socialMediaConfigs?.myArrayList?.forEach(socialMediaConfig => {
        if (!isEmpty(socialMediaConfig.map && socialMediaConfig.map.name)) {
          const site = {
            key: socialMediaConfig.map.name ?? "",
            icon: socialMediaConfig.map.iconPath ?? "",
          }

          const url = socialMediaConfig.map.redirectUrl ?? ""
          if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
            siteList.push({
              ...site,
              url: encodeURI(url + link + `&text=${document.title}`),
            })
          } else if (
            socialMediaConfig.map.name.toLowerCase().includes("pinterest")
          ) {
            // if (props.asset)
            //   siteList.push({
            //     ...site,
            //     url:
            //       url +
            //       `${origin}&media=${props.asset.url}&is_video=${props.asset.isVideo}$description=${props.asset.description}`,
            //   })
          } else {
            siteList.push({
              ...site,
              url: url + link,
            })
          }
        }
      })

    setSites(siteList)
  }, [socialMediaConfigs])

  const emailLink = e => {
    e.stopPropagation()
    addDataLayer("email a friend", "n/a")
  }

  const socialLinks = e => {
    // temp
    // const { hostname, href} = this;
    // const target = (hostname || href) ? this : e.target;
    const target = e.target

    const nodeUrl = target.hostname.replace(/(^www\.)/, "")
    if (
      !window.excludUrl ||
      (window.excludUrl && !window.excludUrl.includes(nodeUrl))
    ) {
      e.stopPropagation()
      e.preventDefault()
      if (window.handleShowModal) window.handleShowModal(target.href)
    } else if (target.href) {
      window.open(target.href)
    }
    const key = target.siteKey || nodeUrl || target.hostname
    try {
      addDataLayer(key.split(".com")[0], target.href)
      // eslint-disable-next-line no-empty
    } catch (ee) {}
  }

  const handleClickOutside = e => {
    if (shareRef.current && !shareRef.current.contains(e.target)) {
      setShareCart({ ...shareCart, show: false })
    }
  }

  useEffect(() => {
    copyBtnRef?.current?.addEventListener("click", copyLink, false)
    shareBoxRef?.current?.addEventListener("click", shareBox, false)
    emailBtnRef?.current?.addEventListener("click", emailLink, false)
    if (shareBoxRef?.current) {
      Array.from(
        shareBoxRef.current.getElementsByClassName("kf-social-links")
      )?.forEach(link => {
        link?.addEventListener("click", socialLinks, false)
      })
    }

    if (shareCart.show) {
      document.addEventListener("mousedown", handleClickOutside)
      document.addEventListener("touchstart", handleClickOutside)
    }

    return () => {
      // garbage collection
      copyBtnRef?.current?.removeEventListener("click", copyLink, false)
      shareBoxRef?.current?.removeEventListener("click", shareBox, false)
      emailBtnRef?.current?.removeEventListener("click", emailLink, false)
      document.removeEventListener("mousedown", handleClickOutside)
      document.removeEventListener("touchstart", handleClickOutside)

      if (shareBoxRef?.current) {
        Array.from(
          shareBoxRef.current.getElementsByClassName("kf-social-links")
        )?.forEach(link => {
          link?.removeEventListener("click", socialLinks, false)
        })
      }
    }
  }, [sites, shareCart.show])
  // temp
  // const { internallinkposition, internallinktype, internallinkzonename } = {}

  const analyticData = analyticEventData || {
    internalLinkPosition: "n/a",
    internalLinkType: "n/a",
    internalLinkZoneName: "n/a",
  }

  const handleClick = e => {
    const selELement = document.getElementById(id)
    if (shareCart.show && !selELement?.contains(e.target)) handleShareCart()
    // if (
    //   props.componentProp?.showModal &&
    //   window.shareSrcElement !== null &&
    //   window.shareSrcElement !== undefined &&
    //   !shareRef.current.contains(e.target)
    // ) {
    //   const shareElems = [...document.getElementsByClassName("share-cmp")]
    //   shareElems.map(el => {
    //     el.style.display = "none"
    //   })
    //   window.shareSrcElement = null
    // }
    return true
  }

  const handleClose = e => {
    if (e.keyCode === 27) {
      handleShareCart()
    }
  }
  useEffect(() => {
    if (shareCart.show) {
      // document.addEventListener("click", handleClick)
      document.addEventListener("keydown", handleClose)
      return () => {
        document.removeEventListener("click", handleClick)
        document.removeEventListener("keydown", handleClose)
      }
    }
    // if (props.componentProp?.showModal && shareCart.show) {
    //   document.addEventListener("click", handleClick)
    // }
  }, [shareCart.show])

  const copyLink = e => {
    e.stopPropagation()
    e.preventDefault()
    navigator.clipboard.writeText(url)
    setCopyIcon(true)
    setTimeout(() => {
      setCopyIcon(false)
    }, 3000)
    addDataLayer("copy link", url ?? "n/a")
  }

  const shareBox = e => {
    e.stopPropagation()
    e.preventDefault()
  }

  const handleDownload = async () => {
    setDownloading(true)
    await handleZipDownload(specFiles)
    setDownloading(false)
  }

  const addDataLayer = (siteKey, link) => {
    const {
      eventAction = "n/a",
      eventName = "n/a",
      eventType = "informative",
      eventMsg = "n/a",
      eventStatus = "n/a",
      internalLinkPosition = "n/a",
      internalLinkType = "n/a",
      internalLinkZoneName = "n/a",
      internalLinkURL,
      custom,
    } = analyticData

    const eventInfo = {
      eventAction,
      eventName,
      eventType,
      eventMsg,
      eventStatus,
      internalLinkName: siteKey,
      internalLinkPosition,
      internalLinkType,
      internalLinkZoneName,
      internalLinkURL: link || internalLinkURL || "n/a",
      clickInternalLinks:
        siteKey === "share cart" || siteKey === "email a friend"
          ? "true"
          : "false",
    }

    if (window.dataLayerEventType) {
      eventInfo.internalLinkType = window.dataLayerEventType
    }

    if (window.dataLayerEventZoneName) {
      eventInfo.internalLinkZoneName = window.dataLayerEventZoneName
      if (eventAction === "n/a") {
        eventInfo.eventAction = window.dataLayerEventZoneName + ":share"
        eventInfo.eventName = window.dataLayerEventZoneName + ":share"
      }
    }

    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    let productInfo
    if (custom) {
      try {
        productInfo = JSON.parse(custom).productInfo
      } catch (e) {}
    }
    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      eventInfo,
      productInfo,
    })
  }

  return (
    <>
      <ConditionalWrapper
        condition={enableDownload}
        wrapper={children => (
          <div
            className={`download-specs${
              mobileView ? `--mobile` : ` d-none d-lg-block`
            }`}
          >
            <p>{sanitizeInnerHtml(i18n.shareCartDesc)}</p>
            <div
              className={`download-specs${mobileView ? `--mobile` : ``}__cta`}
            >
              <span
                role="button"
                tabIndex="0"
                onClick={() => handleShareCart()}
                name="socialShareModelClose"
              >
                {loading ? (
                  <div
                    className="loading-spinner"
                    style={{ marginRight: 0 }}
                  ></div>
                ) : (
                  <img src={ShareIcon?.src} role="presentation" alt="share" />
                )}
              </span>
              {specFiles?.length > 0 && (
                <span
                  role="button"
                  tabIndex="0"
                  className="gbh-data-layer"
                  data-gbh-data-layer='{"eventAction":"cart:landing page:download specs","eventName":"cart:landing page:download specs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"download specs","internalLinkPosition":"cart","internalLinkType":"cart:download","internalLinkZoneName":"cart:landing page:order summary","internalLinkURL":"n/a","clickInternalLinks":"true"}'
                  onClick={handleDownload}
                >
                  {i18n.downloadSpecs}
                  {downloading ? (
                    <div className="loading-spinner"></div>
                  ) : (
                    <img src={DownloadIcon?.src} role="presentation" alt="" />
                  )}{" "}
                </span>
              )}
            </div>
            {children}
          </div>
        )}
      >
        {shareCart.show || !enableDownload ? (
          <div className="social-share" id="kf-order-summary" ref={shareRef}>
            <div className="social-share__box" ref={shareBoxRef}>
              <div className="social-share__sites">
                {shareCart.id ? (
                  <div className="social-share__shared-cart-number">
                    {i18n.yourSharedCartNumber}
                  </div>
                ) : (
                  <ul role="list">
                    {sites.map((site, i) => {
                      return (
                        <li key={i} role="listitem">
                          <a
                            id={`kf-social-links-${i}`}
                            rel="noreferrer"
                            href={site.url}
                            className="kf-social-links"
                            aria-label={`${i18n.linksCTA(site.key)} ${
                              i18n.openNewTabText
                            }`}
                            target="_blank"
                          >
                            <img
                              aria-hidden="true"
                              src={`${process.env.NEXT_PUBLIC_AUTHORBASEURL}${site.icon}`}
                              alt={site.key}
                              className={`social-share__${site.key}`}
                            />
                          </a>
                        </li>
                      )
                    })}
                  </ul>
                )}
              </div>
              <div className="social-share__actions" role="list">
                <div role="listitem">
                  <div
                    tabIndex="0"
                    role="button"
                    ref={copyBtnRef}
                    className="social-share__cta"
                  >
                    <img
                      className="social-share__copy-link-icon"
                      aria-hidden
                      src={`${process.env.NEXT_PUBLIC_AUTHORBASEURL}${socialShareCopyIconPath.current}`}
                      role="presentation"
                      alt=""
                    />
                    {copyIcon ? i18n.copyLinkIndication : i18n.copyLink}
                  </div>
                </div>
                <div role="listitem">
                  <a
                    className="social-share__cta social-share__email"
                    aria-label={`${i18n.email} ${i18n.openNewTabText}`}
                    onKeyDown={() => handleShareCart()}
                    ref={emailBtnRef}
                    href={sanitizeUrl(
                      `mailto:?subject=${
                        i18n.mailSubject
                      }&body=${encodeURIComponent("" + link)}`
                    )}
                  >
                    <img
                      src={`${process.env.NEXT_PUBLIC_AUTHORBASEURL}${socialShareEmailIconPath.current}`}
                      role="presentation"
                      alt=""
                    />
                    {i18n.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </ConditionalWrapper>
    </>
  )
}
export default SocialShare
